<template>
  <button class="Drop-Menu-Item" @click="toApprovePost">
    <div class="Drop-Menu-Item__svg-box">
      <LoaderCircle :color="'var(--blue-600)'" :size="25" v-if="isLoading" />
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" v-else>
        <g clip-path="url(#clip0_2193_273400)">
          <path stroke="var(--gray-600)" d="M2.66667 6.675C3.74657 6.675 4.72055 6.02568 5.1359 5.02885L6.82362 0.978303C6.88085 0.840949 7.02406 0.760005 7.17125 0.781812L8.84818 1.03025C9.01776 1.05537 9.13867 1.20789 9.12443 1.37873L8.87246 4.40242C8.81537 5.08747 9.35598 5.675 10.0434 5.675H13.7534C13.9613 5.675 14.1157 5.86754 14.0706 6.0705L12.6891 12.2874C12.5544 12.8937 12.0167 13.325 11.3957 13.325H0.675V6.675H2.66667Z" />
          <rect fill="var(--gray-600)" x="3" y="7" width="1" height="6" />
        </g>
        <defs>
          <clipPath id="clip0_2193_273400">
            <rect width="15" height="14" fill="transparent"/>
          </clipPath>
        </defs>
      </svg>
    </div>
    Опубликовать
  </button>
</template>

<script setup>
  import { computed, defineProps, ref } from 'vue';
  import { useStore } from 'vuex';
  import { Props } from './scripts/props.js';
  import { approvePost } from './api/approvePost.js';
  import { callOverlay } from '@/Groups/OverlayManager/public/utils/callOverlay.js';
  //--------------------------------------------
  import LoaderCircle from '@ui/Loaders/LoaderCircle/LoaderCircle.vue';
  //--------------------------------------------
  const store = useStore();
  const props = defineProps(Props());
  //--------------------------------------------
  const ID = props.postId;
  //--------------------------------------------
  const isLoading = ref(false);
  //--------------------------------------------
  //Получить пост для добавления в избраннное
  const get_post = computed(() => store.state.ContentSystem.Alpha.list[ID]);
  //--------------------------------------------
  //Опубликовать пост
  const toApprovePost = async() => {
    if(isLoading.value) return;
    try{
      toToggleLoading(true);
      const data = {
        content_type: get_post.value.content_type,
        object_id: get_post.value.id,
      }
      await approvePost(data);
      get_post.value.live = true;
      callOverlay({ text: 'Пост был успешно опубликован', color: 'green', icon: 'alpha' });
    }catch(error){
      console.error('Ошибка публикования поста', error);
      callOverlay({ text: 'Ошибка при публикации поста', color: 'red', icon: 'alpha' });
    }finally{
      toToggleLoading(false);
    }
  }
  //Обозначить процесс опубликования поста
  const toToggleLoading = (status) => isLoading.value = status;
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>